import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { shortDate } from '@app/utils/formatters';
import moment from 'moment';

const getInitialStartDate = () => {
    const initialStartDate = moment().subtract(3, 'months').toDate();
    initialStartDate.setHours(0);
    initialStartDate.setMinutes(0);
    initialStartDate.setSeconds(0);
    return initialStartDate;
};

const getInitialEndDate = () => {
    return moment().subtract(36, 'hours').toDate();
};

export type FilterState = {
    title: string;
    value: any;
    filterValue?: any;
    displayValues: string[];
    options?: any[];
};

export type FiltersInitialState = {
    Accounts: FilterState;
    'Media Type': FilterState;
    Caption: FilterState;
    startDate: FilterState;
    endDate: FilterState;
    Campaigns: FilterState;
};

const useFiltersInitialState = (): FiltersInitialState => {
    const { t } = useTranslation('common');

    return useMemo(() => {
        const initialStartDate = getInitialStartDate();
        const initialEndDate = getInitialEndDate();

        return {
            Accounts: {
                title: t('filters.accounts'),
                value: {},
                filterValue: {},
                displayValues: [],
            },
            'Media Type': {
                title: t('filters.mediaTypes'),
                value: {},
                displayValues: [],
            },
            Caption: {
                title: t('filters.caption'),
                value: '',
                displayValues: [],
            },
            startDate: {
                title: t('filters.startDate'),
                value: initialStartDate,
                displayValues: [shortDate(initialStartDate)],
            },
            endDate: {
                title: t('filters.endDate'),
                value: initialEndDate,
                displayValues: [shortDate(initialEndDate)],
            },
            Campaigns: {
                title: t('filters.campaigns'),
                value: {},
                displayValues: [],
                options: [],
            },
        };
    }, [t]);
};

export default useFiltersInitialState;
